export default __webpack_public_path__ + "static/media/Karunya Kreatives.87c15f7d.png";